import React from "react";
import { RadioGroup, RadioGroupItem } from "ui/components/radio-group";
import { Label } from "ui/components/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "ui/components/select";

export function CategoryRadioGroup({
  value,
  onValueChange,
  categories,
  disabled,
  disabledMessage = "Select a category first to view options",
  emptyMessage = "No categories available",
}) {
  if (disabled) {
    return (
      <div className="flex flex-col items-center justify-center p-6 border border-dashed border-gray-200 rounded-lg bg-gray-50/50 text-center transition-all duration-200">
        <span className="text-sm font-medium text-gray-500">{disabledMessage}</span>
      </div>
    );
  }

  if (!categories || categories.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center p-6 border border-dashed border-gray-200 rounded-lg bg-gray-50/50 text-center transition-all duration-200">
        <span className="text-sm font-medium text-gray-500">{emptyMessage}</span>
      </div>
    );
  }

  return (
    <RadioGroup
      value={value}
      onValueChange={onValueChange}
      className="grid grid-cols-1 gap-2"
      // className="grid grid-cols-1 gap-0 border rounded-lg border-gray-200"
    >
      {categories?.map((cat) => {
        const isSelected = value === cat.id;
        return (
          <div
            key={cat.id}
            className={`flex items-start space-x-3 rounded-lg border p-3 transition-all duration-200 cursor-pointer border-gray-200 bg-white hover:bg-gray-50 `}
            // className={`flex items-start space-x-3 rounded-lg p-3 transition-all duration-200 cursor-pointer border-b`}
            onClick={() => onValueChange(cat.id)}
          >
            <div className="flex-1 space-y-1">
              <Label
                htmlFor={cat.id}
                className="text-sm font-semibold text-gray-900 cursor-pointer"
              >
                {cat.label}
              </Label>
              {cat.description && (
                <p className="text-sm text-gray-500 leading-relaxed">
                  {cat.description}
                </p>
              )}
            </div>
            <RadioGroupItem value={cat.id} id={cat.id} className="cursor-pointer size-5" />
          </div>
        );
      })}
    </RadioGroup>
  );
}

export function SubCategorySelect({ value, onValueChange, subCategories, disabled }) {
  return (
    <Select
      disabled={disabled}
      onValueChange={onValueChange}
      value={value}
    >
      <SelectTrigger className="w-full max-w-none">
        <SelectValue placeholder={disabled ? "Select category first" : "Select"} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {subCategories?.map((item) => (
            <SelectItem key={item.id} value={item.id}>
              {item.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
